<template>
  <div class="pins slikha">
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
    <van-list
    v-if="dataList.length>0"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="pin1 ditus bott"
        v-for="(list, index) in dataList"
        :key="index"
      >
        <van-row class="pbotts">
          <van-col span="16">
            <van-col span="24" class="heise">{{ list.courseName }}</van-col>
            <span class="lanm biao-span" v-if="list.videoVoList.length>0">视频可下载</span>
             <span class="hongmu biao-span" v-if="!list.courseReflect">请填写反思</span>
            <van-col span="24" :class="list.videoVoList.length==0&&list.courseReflect?'kujis':''">
              <van-col span="24" style="font-size: 12px !important"
                >开始时间：{{ list.beginTime }}</van-col
              >
            </van-col>
          </van-col>
          <van-col span="8" @click="xuajh(list)">
            <van-col span="24" class="magtop" style="text-align: right">
              <!-- <van-col span="24" v-if="!list.courseReflect">
                <span class="jinru" style="font-size: 12px !important">上传课后反思</span>
              </van-col> -->
              <van-col span="24">
                <span class="jinru" style="font-size: 12px !important;">查看详情</span>
              </van-col>
            </van-col>
          </van-col>
        </van-row>
      </div>
    </van-list>
    <van-empty v-if="totalCount == 0" description="暂无申报记录" />
    <div class="guazai" @click="yxuanh">
      <van-icon name="plus" style="margin-top: 10px;"/><br/>
      <span class="shenbao" style="font-size: 12px !important;">申报</span>
    </div>
  </div>
</template>

<script>
import { declaregetDeclareListByCreatorId,siteurl } from "@/api/home";
import { Toast } from "vant";
export default {
  data() {
    return {
      pageNum: 1,
      totalCount: 0,
      dataList: [],
      loading: false,
      finished: false,
      show: false,
    };
  },
  watch: {},
  components: {},
  methods: {
    declaregetDeclareListByCreatorId() {
      this.show = true;
      let that = this;
      let params = {
        pageNum: this.pageNum,
        pageSize: 10,
      };
      declaregetDeclareListByCreatorId(params)
        .then((res) => {
          // that.dataList=res.data.data.dataList
          for (var i = 0; i < res.data.data.dataList.length; i++) {
            that.dataList.push(res.data.data.dataList[i]);
          }
          that.totalCount = res.data.data.totalCount;
          that.show = false;
          that.loading = false;
        })
        .catch(() => {
          that.show = false;
          that.loading = false;
        });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.pageNum = 1;
      this.dataList = [];
      this.loading = true;
      this.declaregetDeclareListByCreatorId();
    },
    onLoad() {
      if (this.dataList.length == this.totalCount) {
        this.finished = true;
      } else {
        this.pageNum = this.pageNum + 1;
        this.declaregetDeclareListByCreatorId();
      }
    },
    xuajh(s){
      localStorage.setItem("xq", JSON.stringify(s));
      this.$router.push({
        path: "/declare",
        query: {
          xq:1 ,
        },
      });
    },
    yxuanh(){
      this.$router.push({
        path: "/declare",
      });
    }
  },
  mounted() {
    let token = localStorage.getItem("token");
    if(token==''||!token){
      let local=siteurl+"#/log"
              window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri="+ encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect"
    }
    this.declaregetDeclareListByCreatorId();
  },
};
</script>

<style>
.slikha .van-empty__image {
  width: 160px;
  height: 160px;
}
</style>


// WEBPACK FOOTER //
// src/components/declare/index.vue